var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 47C47 41.2218 45.8619 35.5003 43.6507 30.1619C41.4395 24.8236 38.1985 19.9731 34.1127 15.8873C30.0269 11.8015 25.1764 8.56051 19.8381 6.3493C14.4997 4.13809 8.77816 3 3 3",
    stroke: "#FFDE17",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderLine);
export default __webpack_public_path__ + "static/media/LoaderLine.4591086933acb7a9ac9c5f880c587cb9.svg";
export { ForwardRef as ReactComponent };